//an ingredeint is either bought fresh or typically in stock
import React from "react"
import {removeIngredient,renameIngredient,setItemStocked} from "../service.js";
export default function Ingredient({id,mealID,label,stocked,justMade,updateMeals,mealIndex,ingredientIndex}){

  let [editMode,setEditMode] = React.useState(justMade)
  function enterEditMode(){
    setEditMode(previousEditMode => !previousEditMode)
  }

  function handleTickUntick(){
    updateMeals(prevMeals =>
      prevMeals.map((meal,i) => 
      {
        return i !== mealIndex ? meal : {...meal,ingredients : (
            meal.ingredients.map((ingredient,j) => 
              j !== ingredientIndex ? ingredient : {...ingredient, stocked: !prevMeals[mealIndex].ingredients[ingredientIndex].stocked}
            )
        )}
      })
    )
    setItemStocked(mealID,id,!stocked)
  }

  function handleDelete(){
      updateMeals(prevMeals => {
        console.log(`delete ${prevMeals[mealIndex].ingredients[ingredientIndex].label} from ${prevMeals[mealIndex].label}`)
        removeIngredient(prevMeals[mealIndex].id,prevMeals[mealIndex].ingredients[ingredientIndex].id)
        return prevMeals.map((meal,i) => 
        {
          return i !== mealIndex ? meal : {...meal,ingredients : (meal.ingredients.filter(
            (listItem,j) => j !== ingredientIndex)
            )
          }
        }
        )
      }
      )
  }

  function handleEdit(event,setEditMode){
    if (event.key === "Enter") {
      setEditMode(false)
      updateMeals(prevMeals => {
        renameIngredient(prevMeals[mealIndex].id,prevMeals[mealIndex].ingredients[ingredientIndex].id,event.target.value)
        console.log(`renamed ${prevMeals[mealIndex].ingredients[ingredientIndex].label} to ${event.target.value} in ${prevMeals[mealIndex].label}`)
        return prevMeals.map((meal,i) => 
          {
            return i !== mealIndex ? meal : {...meal,ingredients : (
                meal.ingredients.map((ingredient,j) => 
                  j !== ingredientIndex ? ingredient : {...ingredient, label: event.target.value}
                )
            )}
          })
      }
      )
    }
  }
  
  let labelDiv = editMode || justMade ? 
    <input className="ingredient--label" 
    placeholder={label}
    onKeyUp={(e) => handleEdit(e,setEditMode)}
    autoFocus/> 
  : 
    <div className="ingredient--label"
    onClick={enterEditMode}>{label}</div>
  return (
    <div className="ingredient">
    <input 
      className="ingredient--tickBox"
      type="checkbox" checked={stocked ? "checked" : ""} 
      onChange={handleTickUntick}/>
      <button
        className="listItem--deleteButton"
        onClick={() => handleDelete(ingredientIndex)}>X
      </button>
      {labelDiv}
  </div>
  )
}